import { Button, Form } from "antd";
import { StoreValue } from "antd/es/form/interface";
import { IntelligenceFormFieldsEnum } from "../../enum";
import { PlusOutlined } from "@ant-design/icons";
import { FormListFieldData } from "antd/lib";
import { SmlJsonQueryFilter } from "@src/types/intelligence-search";
import { useQueryDependenciesGraphContext } from "../../context/questions-context";
import React from "react";
import { OperatorEnum } from "@src/pages/intelligence-search/enum";
import { PERMISSION_LAYOUT_CHECK } from "@src/components/crud-permission-layout";

export const AddNewQuestionButton: React.FC<{
    add: (defaultValue?: StoreValue, insertIndex?: number) => void;
    productCode?: string;
    platform?: string[];
    fields: FormListFieldData[];
}> = ({ add, productCode, platform, fields }) => {
    const { metaDictionary } = useQueryDependenciesGraphContext();
    const form = Form.useFormInstance();
    const handleAddNewQuestion = () => {
        const questionLatestIndex = fields[fields.length - 1]?.name;
        const questionLatestTimeRange = form.getFieldValue([
            IntelligenceFormFieldsEnum.QUESTIONS,
            questionLatestIndex,
            IntelligenceFormFieldsEnum.TIME_RANGE,
        ]);

        const defaultFilterSelected = ["date_tzutc", "song_start_count"].map((name) => {
            return {
                name,
                meta: metaDictionary[name] ?? {},
            };
        }) as SmlJsonQueryFilter[];

        add({
            [IntelligenceFormFieldsEnum.TIME_RANGE]: questionLatestTimeRange,
            [IntelligenceFormFieldsEnum.JSON_QUERY]: {
                select: defaultFilterSelected.map((s) => s.name),
            },
            [IntelligenceFormFieldsEnum.JSON_QUERY_BUILDER_CONFIG]: {
                selected_assets_or_filters: defaultFilterSelected,
            },
        });
    };
    const hiddenButton = productCode === undefined || platform === undefined;

    React.useEffect(() => {
        if (hiddenButton) return;
        if (fields.length > 0) return;
        const timeoutId = setTimeout(() => {
            handleAddNewQuestion();
        }, 100);
        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hiddenButton, fields]);

    return (
        <div className={`${PERMISSION_LAYOUT_CHECK}`}>
            <Button type="dashed" hidden={hiddenButton} onClick={handleAddNewQuestion} block icon={<PlusOutlined />}>
                New Question
            </Button>
        </div>
    );
};
